import { useEffect } from 'react';

import type { BatteryLevel } from '../entities/battery-level';
import type { AllIdFilters } from '../entities/filters';

export type UseLevelFiltersDeviceProps = {
  id: string | undefined;
  enabledLevels: BatteryLevel[];
  onChange: (filters: Partial<AllIdFilters>) => void;
  filters: AllIdFilters;
};

export function useLevelFiltersDevice({
  id,
  enabledLevels,
  onChange,
  filters,
}: UseLevelFiltersDeviceProps) {
  useEffect(() => {
    if (!id || enabledLevels.length === 0) {
      return;
    }
    const assignedLevels = enabledLevels.map((level) => `${level}Id`);

    const filteredFilters = Object.entries(filters).filter(
      ([key, value]) => assignedLevels.includes(key) && value !== undefined,
    );

    if (assignedLevels.length === filteredFilters.length) {
      onChange({ deviceId: undefined });
    }
  }, [id, enabledLevels, filters, onChange]);
}
